import cx from 'classnames';
import React from 'react';

import {useToggle} from '../common/hooks';
import {usePageProps} from '../common/hooks/usePageProps';

interface IProps {
    className?: string;
}

export function FlashMessage({className}: IProps) {
    const {
        flash: {message},
    } = usePageProps();

    const [dismissed, dismiss] = useToggle(false);

    if (!message || dismissed) {
        return null;
    }

    return (
        <div
            className={cx(
                'bg-ok-fam-green rounded text-white relative',
                className,
            )}
        >
            {message}
            <span
                className="absolute ml-6 cursor-pointer"
                onClick={dismiss}
            >
        ✕
      </span>
        </div>
    );
}
